import { useRouter } from 'next/router';

import useI18n from '@i18n';

const LanguageSwitch: React.FC = () => {
    const { locale } = useI18n();
    const router = useRouter();

    const newLocale = locale === 'ru' ? 'en' : 'ru';
    const path = router.asPath.replace(locale, newLocale);

    return (
        <a
            id="HeaderLanguageDropdown"
            className="items-center hidden uppercase md:flex hover:text-blueGray-800 leading-full text-blueGray-600 text-[16px]"
            href={`${process.env.NEXT_PUBLIC_INSTANCE_PREFIX}${path}`}
        >
            {newLocale}
        </a>
    );
};

export default LanguageSwitch;
